export function redirectUrlError(value: string): string | undefined {
  if (!value.trim()) return undefined
  try {
    const url = new URL(value.trim())
    if (value.trim().length > 2048 || !/^https?:\/\//i.test(value.trim()) || !['http:', 'https:'].includes(url.protocol) || url.username || url.password) throw new Error()
    if (['youwont.xyz', 'www.youwont.xyz', 'dev.youwont.xyz'].includes(url.hostname) && url.pathname.startsWith('/u/')) throw new Error()
    return undefined
  } catch {
    return 'Enter a full http:// or https:// website link, without login details or another YouWont code.'
  }
}

export function redirectDelayError(value: number): string | undefined {
  return Number.isInteger(value) && value >= 0 && value <= 3600
    ? undefined
    : 'Enter a whole number from 0 to 3600 seconds.'
}
